export const AWS_CONFIG = {
  Auth: {
    identityPoolId: process.env.VUE_APP_IDENTITY_POOL_ID,
    region: process.env.VUE_APP_REGION,
    userPoolId: process.env.VUE_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_USER_POOL_WEB_CLIENT_ID,
    mandatorySignIn: false
  },
  API: {
    endpoints: [
      {
        name: 'FILE_EXCHANGE_API',
        endpoint: process.env.VUE_APP_FILE_EXCHANGE_API,
        region: process.env.VUE_APP_REGION
      }
    ]
  }
}

export const OPENID_CONNECT = {
  ClientId: process.env.VUE_APP_USER_POOL_WEB_CLIENT_ID,
  AppWebDomain: process.env.VUE_APP_APP_WEB_DOMAIN,
  TokenScopesArray: [
    'profile',
    'email',
    'openid',
    'aws.cognito.signin.user.admin'
  ],
  RedirectUriSignIn: process.env.VUE_APP_REDIRECT_URI_SIGN_IN,
  RedirectUriSignOut: process.env.VUE_APP_REDIRECT_URI_SIGN_OUT
}
